module.exports = __webpack_public_path__ + "static/img/product_22.6464fbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_22.jpg
// module id = Jrb1
// module chunks = 2